<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 询价单详情 -->
<template>
  <div>
    <div class="container">
      <enquiry-detail-com
        v-if="enquiryDetail"
        :enquiry-status="enquiryStatus"
        @queryAuditBusinessFlowLogList="queryAuditBusinessFlowLogList"
      />
      <!-- <choose-business-priceDetail-detail v-if="true" /> -->
      <choose-business-priceDetail-detail
        v-if="chooseBusinessPriceDetailDetail"
        is-choice
        :enquiry-status="enquiryStatus"
        @getCreateSource="getCreateSource"
        @queryAuditBusinessFlowLogList="queryAuditBusinessFlowLogList"
      />

      <!-- 审批流组件-->
      <approval-process :approval-data="approvalData" approval-title="发起审批记录" class="approval-wrapper" />
      <!--悬赏定价的审批流展示-->
      <approval-process
        v-if="setPriceApprovalData.length > 0"
        :approval-data="setPriceApprovalData"
        approval-title="选商定价审批记录"
      />
    </div>

    <div class="handle-button">
      <eui-btn type="secondary" @click="toBack(null)">< 返回</eui-btn>
      <div v-if="enquiryTypeFlag == 'true'" class="right-btn">
        <eui-btn @click="submitSaveForm(false)">审批拒绝</eui-btn>
        <eui-btn class="btn submit-btn" @click="submitSaveForm(true)">审批通过</eui-btn>
      </div>
    </div>

    <e-dialog
      :dialog-title="dialogType"
      :center-dialog-visible="approveDialogVisible"
      :popup-width="'600px'"
      :show-close="false"
      @updateVisible="approveDialogVisible = false"
      @submitPopupData="submitPopupData"
      @resetPopupData="approveDialogVisible = false"
    >
      <el-form ref="refuseForm" :model="refuseForm" :inline="true" label-width="100px">
        <el-form-item>
          <div style="margin-left: 35px">
            {{
              dialogType == '审核通过'
                ? '您正在操作询比价审批通过，请详细核对询比价信息。此操作无法撤销，是否继续？'
                : '您正在操作询比价审批拒绝，此操作无法撤销，是否继续？'
            }}
          </div>
        </el-form-item>
        <el-form-item :label="dialogType == '审核通过' ? '审核意见' : '拒绝原因'" prop="refuseReason">
          <el-input
            v-model="refuseForm.refuseReason"
            style="width: 320px"
            :placeholder="dialogType == '审核通过' ? '同意' : '请填写拒绝原因'"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 20px" @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </e-dialog>
  </div>
</template>
<script>
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import { dealAttachmentName } from '@/modules/projectA/utils/utils';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/auditManagement/index';
import enApi from '@/modules/projectA/api/enquiry';

import ChooseBusinessPriceDetailDetail from './components/chooseBusinessPriceDetail.vue';
import EnquiryDetailCom from './components/enquiryDetailCom.vue';

export default {
  components: {
    EProcess,
    eDialog,
    approvalProcess,
    ChooseBusinessPriceDetailDetail,
    EnquiryDetailCom,
  },
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    return {
      activeIndex: 1,
      detailLoading: false,
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      supplierTableList: [],
      enquiryTypeObj,
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 列表验证+列表数据
      formData: {
        includeFreight: 0,
        enquiryType: 1,
        address: '',
        enquiryName: '',
        realName: '',
        mobile: '',
        quotationDeadline: '',
        releaseTimeStart: '',
        arrivalTime: '',
      },
      enquiryDetailList: [],
      tableData: [],
      enquiryTypeFlag: false,
      approvalData: [],
      setPriceApprovalData: [], // 悬赏定价审批流数据
      firstData: {},
      // 定向询价供应商列表
      enquirySupplierList: [],
      addressVisible: false,
      enquiryAttachmentUrlShow: [],
      approveDialogVisible: false,
      refuseForm: {
        refuseReason: '',
      },
      refuseRules: {
        refuseReason: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
      },
      dialogType: '审核通过',

      enquiryStatus: -1,
      isChoice: false,
    };
  },
  computed: {
    enquiryDetail() {
      if (!this.enquiryStatus) return false;
      const arr = [0, 1, 2, 3, 4, 9, 10, 11, 13];
      return arr.includes(Number(this.enquiryStatus));
    },
    chooseBusinessPriceDetailDetail() {
      if (!this.enquiryStatus) return false;
      const arr = [5, 6, 7, 12, 14];
      return arr.includes(Number(String(this.enquiryStatus)));
    },
  },

  created() {
    this.enquiryTypeFlag = this.$route.query.flag;
    console.log('this.flag', this.enquiryTypeFlag);
  },
  mounted() {
    let { enquiryId, enquiryStatus } = this.$route.query;
    this.enquiryStatus = enquiryStatus;
    enquiryStatus = Number(enquiryStatus);
    /*
      0: "草稿", // 已保存
      1: "待审核", // 有
      2: "待报价", // 有
      3: "待揭示", // 有
      4: "已揭示", // 有
      5: "询价完成", // 有
      6: "生成订单", // 已下单
      7: "订单完成", // 有
      8: "询价作废", // 没有
      9: "审核拒绝", // 有
      10: "询价过期" // 没有
    */
    switch (enquiryStatus) {
      case 0:
      case 1:
      case 9:
      case 11:
        this.activeIndex = 1;
        break;
      case 2:
      case 3:
      case 4:
        this.activeIndex = 2;
        break;
      case 12:
      case 14:
        this.activeIndex = 3;
        break;
      case 5:
      case 6:
      case 7:
        this.activeIndex = 4;
        break;
      case 8:
      case 10:
        this.activeIndex = -1;
        break;
      default:
        this.activeIndex = -1;
        break;
    }
    this.getDetailInfo({ enquiryId: Number(enquiryId) });
  },
  methods: {
    /* async getDetailInfo(params) {
      const { enquiryStatus } = this.$route.query;
      const result = await Api.checkEnquiryPower({
        enquiryId: params.enquiryId,
        checkType: 0,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.enquiryPower = false;
          this.$message.warning('暂无权限查看此信息。');
          this.$router.replace('/enquiryManage/enquiry');
          return;
        }
      }

      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          this.purchaseCompanyId = res.data.purchaseCompanyId;
          this.enquiryStatus = res.data.enquiryStatus;
          if (this.enquiryStatus !== Number(this.$route.query.enquiryStatus)) {
            // this.$message.warning('暂无权限查看此信息。');
            this.$message({
              duration: 5000,
              type: 'warning',
              message: '暂无权限查看此信息。',
            });
            this.$router.replace('/enquiryManage/enquiry');
            return;
          }
          if (this.enquiryStatus !== 8 || this.enquiryStatus !== 10) {
            this.isChoice = res.data.purchaseCompanyId === this.companyId;
          } else {
            this.isChoice = true;
          }
          // this.isChoice = res.data.purchaseCompanyId === this.companyId; // && res.data.viewOfferCount >= 1;
          this.getTableList(res.data.purchaseCompanyId);
          console.log(this.isChoice, 'this.isChoice');
        }
      });
    }, */
    getCreateSource(createSource) {
      console.log(createSource, 'createSourcecreateSourcecreateSource');
      this.createSource = createSource;
    },
    dealAttachmentName,
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    toBack(times) {
      if (times) {
        this.$router.push({
          path: '/auditManagement/enquiry',
          query: { t: times },
        });
      } else {
        this.$router.push({ path: '/auditManagement/enquiry' });
      }
    },
    uploadDesc(index, row) {
      const fileArr = row.enquiryDetailAttachmentList;
      const file = fileArr[0];
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    // 采购商-查询询价单详情
    async getDetailInfo(params) {
      this.detailLoading = true;
      await enApi.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.formData = { ...data };
          // 展示转换
          // 展示转换
          if (data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }
          if (data.enquirySupplierList && data.enquirySupplierList.length !== 0) {
            this.enquirySupplierList = [...data.enquirySupplierList];
          }
          this.enquiryDetailList = [...data.enquiryDetailList];

          if (this.enquiryStatus !== 8 || this.enquiryStatus !== 10) {
            this.isChoice = res.data.purchaseCompanyId === this.companyId;
          } else {
            this.isChoice = true;
          }

          // this.queryAuditBusinessFlowLogList();
        }
      });
    },
    // 获取审批流数据
    /* async queryAuditBusinessFlowLogList() {
      const params = {
        companyId: this.formData.purchaseCompanyId,
        businessId: this.formData.enquiryId,
        businessAuditType: 5, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200') {
        const data = res.data || [];

        // 封装发起审批 的数据 插入第一条
        this.firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: this.formData.mobile,
            auditMemberName: this.formData.createMemberName,
            approveTime: this.formData.createTime,
          },
        };
        data.unshift(this.firstData);

        // 询比价封装最后一条数据  待审批   0-待审批; 1-审批通过; 2-审批拒绝;  3-审批中
        // 运营商待审核：11、13
        // 运营商审核中：1
        // 运营商审核拒绝：9
        // 运营商审核成功：2，3，4，5，6，7，8，10

        const lastData = {
          auditStatus: '',
          step: '台审批',
          tip: '若有问题，可咨询致电平台运营张经理，电话：0898-65860160',
          nodeMember: {
            auditMemberName: '易派客平台审核',
            auditRemark: this.formData.refuseReason || '',
          },
          nodeMemberList: [
            {
              auditMemberName: '易派客平台审核',
            },
          ],
        };
        if (this.formData.enquiryStatus === 1) {
          // 审核中
          lastData.auditStatus = 3;
        } else if (this.formData.enquiryStatus === 11 || this.formData.enquiryStatus === 13) {
          // 待审核
          lastData.auditStatus = 0;
        } else if (this.formData.enquiryStatus === 9) {
          // 审核拒绝
          lastData.auditStatus = 2;
        } else {
          lastData.auditStatus = 1;
        }

        data.push(lastData);

        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }

      this.queryAuditSetPriceFlowLogList();
    }, */

    // 获取审批流数据
    async queryAuditBusinessFlowLogList(firstData, handleData, setPriceFirstData, purchaseCompanyId) {
      const params = {
        companyId: purchaseCompanyId,
        businessId: this.$route.query.enquiryId,
        businessAuditType: 5, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      this.purchaseCompanyId = purchaseCompanyId;
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200') {
        const data = res.data || [];
        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        this.firstData = firstData;

        // 询比价封装最后一条数据  待审批   0-待审批; 1-审批通过; 2-审批拒绝;  3-审批中
        // 运营商待审核：11、13
        // 运营商审核中：1
        // 运营商审核拒绝：9
        // 运营商审核成功：2，3，4，5，6，7，8，10

        const lastData = {
          auditStatus: '',
          step: '台审批',
          tip: '若有问题，可咨询致电平台运营张经理，电话：0898-65860160',
          nodeMember: {
            auditMemberName: '易派客平台审核',
            auditRemark: handleData.refuseReason || '',
          },
          nodeMemberList: [
            {
              auditMemberName: '易派客平台审核',
            },
          ],
        };
        if (handleData.enquiryStatus === 1) {
          // 审核中
          lastData.auditStatus = 3;
        } else if (handleData.enquiryStatus === 11 || handleData.enquiryStatus === 13) {
          // 待审核
          lastData.auditStatus = 0;
        } else if (handleData.enquiryStatus === 9) {
          // 审核拒绝
          lastData.auditStatus = 2;
        } else {
          lastData.auditStatus = 1;
        }

        data.push(lastData);

        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
      this.queryAuditSetPriceFlowLogList(setPriceFirstData);
    },
    // 获取选商定价的审批流数据
    async queryAuditSetPriceFlowLogList() {
      const params = {
        companyId: this.formData.purchaseCompanyId,
        businessId: this.formData.enquiryId,
        businessAuditType: 6, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:选商定价
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];
        // 选商定价发起人数据
        const setPriceFirstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: this.formData.selectivePriceAuditMobile,
            auditMemberName: this.formData.selectivePriceAuditMemberName,
            approveTime: this.formData.selectPriceAuditTime,
          },
        };
        data.unshift(setPriceFirstData);
        // 审批流数据封装
        this.setPriceApprovalData = stepUtils.dealStepData(data);
      }
    },
    // 开课时期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 节课时期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },
    async submitSaveForm(val) {
      this.dialogType = val ? '审核通过' : '审核拒绝';
      this.approveDialogVisible = true;
    },

    submitPopupData() {
      if (this.dialogType === '审核拒绝' && !this.refuseForm.refuseReason) {
        this.$message.warning('请输入拒绝原因。');
        return;
      }
      // this.approveDialogVisible = false;
      this.handleConfirm();
    },
    handleCancel() {
      this.approveDialogVisible = false;
      this.refuseForm.refuseReason = '';
    },
    handleConfirm() {
      const params = {
        enquiryAuditStatus: this.dialogType === '审核通过',
        enquiryId: Number(this.$route.query.enquiryId),
        enquiryStatus: Number(this.$route.query.enquiryStatus),
        refuseReason: this.refuseForm.refuseReason,
      };
      this.$refs.refuseForm.validate(async (val) => {
        if (val) {
          const res = await Api.auditEnquiryList(params);

          if (res.code === '200') {
            this.approveDialogVisible = false;
            setTimeout(() => {
              let times = new Date();
              times = times.getTime();
              this.toBack(times);
            }, 1000);
          }
        }
      });
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.enquiry-detail-com {
  background: #fff;
  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }
  }

  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      margin-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
        display: inline-block;
        width: 150px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-shrink: 0;
        flex-grow: 0;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      ::v-deep .el-upload {
        display: block;
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
.handle-button {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
